import {
  Component,
  ComponentRef,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import {DynamicComponentService} from "../../shared/services/dynamic-component/dynamic-component.service";
import {OptionService} from "../../shared/services/option/option.service";
import {Saseung3HelpPopupComponent} from "./saseung3-help-popup.component";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";


@Component({
  selector: 'app-saseung3-help-btn',
  template: `
    <aside #container
           class="page-help-box">

      <a class="page-help-btn" (click)="onClick($event)">
        <i class="ic ic-help"></i>
        <span class="txt">도움말</span>
      </a>
    </aside>
  `,
})
export class Saseung3HelpBtnComponent {
  @ViewChild('container', { read: ViewContainerRef }) container?: ViewContainerRef;
  private componentRef: ComponentRef<Saseung3HelpPopupComponent> | null = null;

  constructor(
    private dynamicSvc: DynamicComponentService,
    private optionSvc: OptionService,
    private globalEventSvc: GlobalEventService,
  ) {

  }

  onClick($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (!this.container === null) {
      throw new Error(`Saseung3HelpBtnComponent::ngOnInit() container is null`);
    }

    if (this.componentRef) {
      this.closePopup();
    }
    else {
      this.componentRef = this.dynamicSvc.createComponent(Saseung3HelpPopupComponent, this.container);
      this.componentRef.instance.close.subscribe((showSaseung: boolean | null) => {
        // console.log('Saseung3HelpBtnComponent::ngAfterViewInit() close.subscribe()', showSaseung);

        if (showSaseung !== null) {
          this.optionSvc.showSaseung = showSaseung;
        }

        this.closePopup();
      });
    }
  }

  private closePopup() {
    this.componentRef?.destroy();
    this.componentRef = null;
  }
}
